var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Account requests")]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row", staticStyle: { "margin-bottom": "40px" } },
        [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              {
                staticClass: "card bg-light",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "float-left" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v("Janusz Noszczyński"),
                    ]),
                    _vm._v(" "),
                    _c("h6", { staticClass: "card-subtitle mb-2 text-muted" }, [
                      _vm._v("janusz@transparentchoice.com"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "float-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success btn-sm",
                        attrs: { type: "button" },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-check",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger btn-sm",
                        attrs: { type: "button" },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-ban",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "list-group list-group-flush" }, [
                  _c("li", { staticClass: "list-group-item" }, [
                    _vm._v("Default"),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "list-group-item" }, [
                    _vm._v("Playground"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer text-muted" }, [
                  _vm._v(
                    "\n                        2 days ago\n                    "
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              {
                staticClass: "card bg-light",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "float-left" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v("Dan Dures"),
                    ]),
                    _vm._v(" "),
                    _c("h6", { staticClass: "card-subtitle mb-2 text-muted" }, [
                      _vm._v("dan@transparentchoice.com"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "float-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success btn-sm",
                        attrs: { type: "button" },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-check",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger btn-sm",
                        attrs: { type: "button" },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-ban",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "list-group list-group-flush" }, [
                  _c("li", { staticClass: "list-group-item" }, [
                    _vm._v("Prioritization 2021"),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "list-group-item" }, [
                    _vm._v("Prioritization 2022"),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "list-group-item" }, [
                    _vm._v("Secret"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer text-muted" }, [
                  _vm._v(
                    "\n                        5 hours ago\n                    "
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }